import { make } from "vuex-pathify";

// properties
const state = {
  items: [],
};
const mutations = make.mutations(state);
const getters = {
  ...make.getters(state),
};
const actions = {
  async bindLists({ dispatch, rootGetters }, data) {
    dispatch("openDBChannel", {
      pathVariables: {
        teamId: rootGetters["user/getTeam"],
      },
    });
  },

  unbindLists({ dispatch }) {
    dispatch("closeDBChannel");
  },

  async add({ dispatch, rootGetters, getters }, data) {
    return dispatch("set", data);
  },

  async edit({ dispatch }, { list, data }) {
    await dispatch("patch", {
      id: list.id,
      ...data,
    });
  },

  // we move the task to the trashed collection
  async remove({ dispatch }, list) {
    await dispatch("patch", {
      id: list.id,
      status: "trashed",
    });
  },
};

export default {
  firestorePath: "teams/{teamId}/teamListsLibrary",
  firestoreRefType: "collection",
  moduleName: "team-lists-library",
  statePropName: "items",
  sync: {
    guard: ["project_id"],
    defaultValues: {
      status: "published",
      version: 1,
    },
  },
  serverChange: {
    convertTimestamps: {
      created_at: "%convertTimestamp%", // default
      updated_at: "%convertTimestamp%", // default
      // define each field like so ↑ in an object here
    },
  },
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
